import { Text } from "../../../text";
import { StepLabelProps } from "./types";
import styles from "./styles.module.scss";

export const StepLabel = ({ isActive, label, dataTestId }: StepLabelProps) => (
  <Text
    size="medium"
    weight={isActive ? "medium" : "regular"}
    className={styles.label}
    dataTestId={`${dataTestId}-label`}
  >
    {label}
  </Text>
);
